import Points from "./Points";
import {listener, onReady, findID} from "../../../../modules/vegas/js/util";

function initPoints() {
	const mapPoints = document.getElementById("points-map");
	if (!mapPoints) return;

	let instance = Points.getOrCreateInstance('points-map');
	instance.request();

	// Сохраняем точку
	listener('click', '#points [data-toggle="save-point"]', function (el) {
		if (el.disabled) return;
		const label = el.innerHTML;
		el.disabled = true;
		el.innerHTML = '<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>';
		el.parentElement.querySelector('[data-points-save-error]')?.remove();
		const restore = () => { el.disabled = false; el.innerHTML = label; };
		Points.setPoint(instance.params.points.set, {
			id: el.dataset.id || null,
			company: el.dataset.company,
			_token: App.csrf
		}, {
			success: function (data) {
				restore();
				let modalSuccess = findID('modal-points-success');
				if (modalSuccess) {
					let modal = new bootstrap.Modal(modalSuccess);
					modal.show();
				}
			},
			error: function () {
				restore();
				const error = document.createElement('p');
				error.className = 'small text-danger mt-2 mb-0';
				error.dataset.pointsSaveError = '';
				error.setAttribute('role', 'alert');
				error.textContent = 'Не удалось сохранить пункт. Попробуйте ещё раз.';
				el.parentElement.append(error);
			}
		});
	}, true);
}

onReady(initPoints);
